import React, { Component } from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import classNames from "classnames";
import jobPropType from "./types/jobType";

class JobDescription extends Component {
  handleNumberOfPositionsLink = () => {
    const jobDetailsLi = document.querySelector(".job-details-li");
    const jobStatusLi = document.querySelector(".job-status-li");

    jobDetailsLi.classList.remove("active");
    jobStatusLi.classList.add("active");
  };

  render() {
    const {
      job: {
        accountManagers,
        considerRelocation,
        contractDuration,
        hasCustomTerms,
        customTerms,
        customTermsUrl,
        degreeRequired,
        feedbackTimescale,
        interviewStages,
        jobType,
        keySkills,
        location,
        numberOfPositions,
        placementFeePercent,
        salary,
        sector,
        vacancyReason,
        visaSponsorship,
      },
      isPortalUser,
      isPartnerUser,
    } = this.props;

    const degreeRequiredIconClass = classNames({
      fas: true,
      "fa-check": degreeRequired,
      "fa-times": !degreeRequired,
    });

    const visaSponsorshipIconClass = classNames({
      fas: true,
      "fa-check": visaSponsorship,
      "fa-times": !visaSponsorship,
    });

    const considerRelocationSponsorshipIconClass = classNames({
      fas: true,
      "fa-check": considerRelocation,
      "fa-times": !considerRelocation,
    });

    const jobDetails = {
      "Job Sector": sector,
      Location: location,
      Salary: Parser(salary),
      Type: jobType,
      "Number of positions": (
        <a
          href="#job-status"
          data-toggle="tab"
          onClick={this.handleNumberOfPositionsLink}
          className="number-of-positions-link"
          title="Job status"
        >
          {numberOfPositions}
        </a>
      ),
      "Contract duration": contractDuration,
      "Account manager": accountManagers,
      "Reason for vacancy": vacancyReason,
      "Must have degree": <i className={degreeRequiredIconClass} />,
      "Will consider VISA sponsorship": (
        <i className={visaSponsorshipIconClass} />
      ),
      "Will consider relocating from EU": (
        <i className={considerRelocationSponsorshipIconClass} />
      ),
      "Stages of interview process": interviewStages,
      "Predicted time for CV feedback": feedbackTimescale,
      Keywords: keySkills,
      "Employer’s specific Terms of Business": Parser(customTerms || ""),
    };

    const NumberOfPositionsTooltip = () => (
      <i
        className="fas fa-info-circle"
        data-toggle="tooltip"
        data-placement="bottom"
        title={`
          This is the total number of available positions 
          on the job. The figure displayed on this page is 
          static, so will not change dependent on the number 
          of offers that have been made
        `}
      />
    );

    return (
      <div id="job-description-engagement-modal">
        {!isPortalUser && (
          <div className="fee-table">
            <div className="row">
              <div
                className="col-xs-6 col-sm-5 current-fee-column"
                id="current-fee-column"
              >
                <div className="fee-table-highlight">Fee:</div>
              </div>
              <div className="col-xs-6 col-sm-7 plans-options">
                <div className="fee-table-highlight">
                  <span id="fee-amount">{placementFeePercent}%</span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div id="job-description">
          {Object.keys(jobDetails).map((detailKey) => {
            const detailValue = jobDetails[detailKey];
            return (
              detailValue && (
                <div className="row table-row" key={detailKey}>
                  <div className="col-sm-5">
                    <div className="title modal-table-title">
                      {detailKey}
                      {detailKey === "Number of positions" && (
                        <NumberOfPositionsTooltip />
                      )}
                      {":"}
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div>{detailValue}</div>
                  </div>
                </div>
              )
            );
          })}
          {hasCustomTerms && (
            <div className="row table-row custom-terms-url-row">
              <div className="col-sm-5" />
              <div className="col-sm-7">
                <a
                  className="custom-terms-url-link"
                  data-test-id="custom-terms-url-link"
                  href={customTermsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="View employer's terms of business"
                >
                  View employer&apos;s terms of business
                </a>
              </div>
            </div>
          )}
        </div>
        <hr />
        {isPartnerUser ? (
          <p className="full-description">
            The full job description and employer details will become available
            once you have accepted the invitation.
          </p>
        ) : (
          <p className="full-description">
            The full job description and employer details will become available
            once you have been approved to work on this vacancy.
          </p>
        )}
        <hr />
      </div>
    );
  }
}

JobDescription.propTypes = {
  job: jobPropType.isRequired,
  isPortalUser: PropTypes.bool.isRequired,
  isPartnerUser: PropTypes.bool.isRequired,
};

export default JobDescription;
